'use strict';

const SELECTORS = {
    body: 'body',
    pdfViewerModalLink: '.js-pdf-viewer-modal',
}

function init() {
    initPdfViewerModal();

    $(window).on('resize', function() {
        initPdfViewerModal();
    });
}

function initPdfViewerModal() {
    $(SELECTORS.pdfViewerModalLink).removeAttr('data-toggle', '');

    if (navigator.pdfViewerEnabled && window.innerWidth > 1024) {
        $(SELECTORS.pdfViewerModalLink).attr('data-toggle', 'modal');
    }
}

module.exports = {
    init: init
}
